<div class="col-md-11 mapa">
    <h5 class="nocaps mt-20">CentralGas S.L.</h5>
    <iframe title="Mapa de ubicación" src="https://www.google.com/maps?q=Avda.%20de%20los%20Pirineos%2C%2031%2C%20nave%206%2C%2028703%20San%20Sebasti%C3%A1n%20de%20los%20Reyes%2C%20Madrid%2C%20Espa%C3%B1a&amp;output=embed" style="border:0;width:100%; min-height:395px;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" name="maps"></iframe>
    <div class="widget footer-address-widget text-left">
        
        <h6 class="footer-address nocaps mt-20">
            Avda. de los Pirineos, 31, nave 6
            <br/>
            28703 San Sebastián de los Reyes
            <br/>
            Madrid, España
        </h6> 
    </div>
</div>









